import type { JSX, ReactNode } from 'react';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface ScenarioConfirmDialogProps {
  open: boolean;
  title: string;
  description: ReactNode;
  confirmLabel: string;
  destructive?: boolean;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ScenarioConfirmDialog = ({
  open,
  title,
  description,
  confirmLabel,
  destructive = false,
  isLoading,
  onCancel,
  onConfirm,
}: ScenarioConfirmDialogProps): JSX.Element => (
  <Dialog open={open} onOpenChange={(isOpen) => (!isOpen ? onCancel() : undefined)}>
    <DialogContent className="sm:max-w-md">
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription asChild>
          <div className="text-sm text-text-muted">{description}</div>
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button type="button" variant="outline" onClick={onCancel} disabled={isLoading}>
          Cancelar
        </Button>
        <Button
          type="button"
          variant={destructive ? 'destructive' : 'default'}
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading ? 'Procesando…' : confirmLabel}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default ScenarioConfirmDialog;
